import React from 'react';
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {Configuration, ConfigurationId} from "./Configuration";
import {ImportConfigurationNullable} from "../../../../common/Types";
import {t} from "../../../../store/localization/TranslMessasge";
import {ImportTranslationKey} from "./ImportTranslationKey";
import ImportPanel from "./ImportPanel";
import {useParams} from "react-router-dom";

function getInitialConfiguration(initialConfigurationId: string | undefined): ImportConfigurationNullable {
    let initialConfiguration = null;
    if (initialConfigurationId) {
        initialConfiguration = Configuration.findById(Configuration.getConfigurations(), initialConfigurationId as ConfigurationId);
    }
    return initialConfiguration;
}

export default function ImportPage() {

    const {initialConfigurationId} = useParams();
    const initialConfiguration = getInitialConfiguration(initialConfigurationId);
    const pageTitle = initialConfiguration != null ? initialConfiguration.pageLabel : t(ImportTranslationKey.TITLE);

    return (
        <Page>
            <PageHeader>
                <PageTitle title={pageTitle} />
            </PageHeader>
            <PageContent>
                <ImportPanel initialConfigurationId={initialConfigurationId as (ConfigurationId | undefined)}/>
            </PageContent>
        </Page>
    );
}
